var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWebLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 166 153",
    width: 166,
    height: 153,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #000000 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3798",
    className: "s0",
    d: "m36.9 35.6l-4.8 5.3h-32.1l16 18-16 17.9h32.1l4.8 5.4 4.8-5.4h32.1l-16.1-17.9 16.1-18h-32.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3798-7",
    className: "s0",
    d: "m107.2 52.3v14h-4.3l4.3 4.4v9.6 10.3l-4.3 4.5h4.3v13.2l24.1-11.9 2.8 3 4.1-4.3h27.2l-9.9-10.5 8.9-4.3-8.4-4.1 9.4-9.9h-27.2l-4.1-4.4-2.2 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3848",
    className: "s0",
    d: "m68.3 108.6l-3.7 1.7 0.9 1.7 12.9 24.4c-10 1.9-14.1 4.8-20.1 9.6l-1.5 1.3 2.7 2.8 1.5-1.2c6.6-5.3 8.9-7.5 20.7-9.3l2.7-0.5-15.2-28.8zm54.1 1.6l-3.6 1.6 0.9 1.7 12.8 24.4c-10 1.9-16.1 7.7-19.1 10.9l2.6 2.9 1.1-1.1c5.1-4.8 11.3-8.4 18.7-9.5l2.7-0.4-15.2-28.8zm-76.4 0.6v1.9l-0.1 31.5c-8.6-4.1-12.2-3.9-21.2-1.7l-2.1 0.6v3.6l2.1-0.5c7.8-1.8 13.3-2.6 22.1 2.6l3.1 1.8 0.1-37.9v-1.9zm56.4 1.6v1.9l-0.1 31.3c-6.9-3.9-13-3.9-21.6-1.5l-2 0.5 1.1 3.6 2-0.5c7-2.1 12.2-2.3 21.5 2.6l3.1 1.9 0.1-37.9v-1.9z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "layer2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect3719",
    className: "s0",
    d: "m24 0h122.9v122.8h-122.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWebLight);
export default __webpack_public_path__ + "static/media/logo-web-light.cb0617144ca4fcc96d543b46081bd7aa.svg";
export { ForwardRef as ReactComponent };